// @flow
/** @jsx h */
/* eslint-disable jsx-a11y/media-has-caption */
import { h, Component } from 'preact'
import bem from '../../../lib/bem'
import { HTML5Video } from '../../lib/components/HTML5Video'
import { testReducedMotion } from '@nrk/feature-tests'

import styles from './VideoLoop.css'

type Props = {
  poster: string,
  sources: {
    mp4: string,
    webm: string,
  },
  size: {
    height: number,
    width: number
  }
}

type State = {
  supportsVideoAutoplay: boolean
}

export class VideoLoop extends Component<Props, State> {
  constructor () {
    super()
    this.state = {
      supportsVideoAutoplay: false
    }
  }

  handleAutoPlay = (supportsVideoAutoplay: boolean) => {
    this.setState({
      supportsVideoAutoplay
    })
  }

  render () {
    const { poster, sources, size } = this.props
    const { supportsVideoAutoplay } = this.state
    const paddingBottom = `${(size.height / size.width) * 100}%`
    const showFallbackImage = !supportsVideoAutoplay
    const autoPlay = !testReducedMotion()
    return (
      <div className={bem(styles.videoLoop, showFallbackImage && 'showFallbackImage')} style={{ paddingBottom }}>
        <img className={styles.videoLoop__fallbackImage} src={poster} alt='' />
        <HTML5Video className={styles.videoLoop__videoElement} preload='auto' autoPlay={autoPlay} loop playsInline muted
          poster={poster}
          sources={sources}
          size={size}
          onPlayError={this.handleAutoPlay} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/v1/article/components/VideoLoop.js